exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".waa8BrsP9BDLwQgBb-1ng{display:flex;flex-direction:row}._3iaVfAgeiJXYvQ-_CLSczc{width:360px;padding:30px 20px;background:#fff}._3RKOmduXi5_-Tj3jUQ5kaG{flex-grow:1}._2A4mWS9e8vaV_631HvLah7{border:1px solid #000000;padding:30px}\n", ""]);

// Exports
exports.locals = {
	"Config": "waa8BrsP9BDLwQgBb-1ng",
	"side": "_3iaVfAgeiJXYvQ-_CLSczc",
	"main": "_3RKOmduXi5_-Tj3jUQ5kaG",
	"limitedCodesLink": "_2A4mWS9e8vaV_631HvLah7"
};